import { tracking } from '@iwoca/frontend-tracking-library';
import { t } from '@lingui/core/macro';
import { useNavigate } from 'react-router-dom';
import { getAmplitudeDefaultEventProperties } from 'utils/amplitudeEvents';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { useTutorials } from './hooks/useTutorials.hook';

type TTour = {
  name: string;
  description: string;
  onClick: () => void;
};

export const usePortalTours = () => {
  const navigate = useNavigate();
  const { triggerNavigationTour } = useTutorials({ autoTriggered: false });

  const handleNavigationTourClick = () => {
    trackEvent('Navigation');
    triggerNavigationTour();
  };

  const handleCalculatorTourClick = () => {
    trackEvent('Calculator');
    navigate(PATH_NAMES.calculator({ tourType: 'manual' }));
  };

  const handleDashboardTourClick = () => {
    trackEvent('Dashboard');
    navigate(PATH_NAMES.home({ tourType: 'manual' }));
  };

  const trackEvent = (tour: string) => {
    tracking.ampli.tutorialStarted({
      ...getAmplitudeDefaultEventProperties(),
      name: tour,
    });
  };

  const getTourData = (): TTour[] => [
    {
      name: t`Navigation tour`,
      description: t`Learn how to move around the Portal, use helpful tools, and create new applications.`,
      onClick: () => handleNavigationTourClick(),
    },
    {
      name: t`Dashboard tour`,
      description: t`Discover how to search, filter, and manage applications efficiently from your dashboard.`,
      onClick: () => handleDashboardTourClick(),
    },
    {
      name: t`Calculator tour`,
      description: t`Quickly calculate and share repayment schedules tailored to your clients.`,
      onClick: () => handleCalculatorTourClick(),
    },
  ];

  return {
    tourData: getTourData(),
  };
};
